const NEW = 'NEW';
const CLEAN = 'CLEAN';
const INFECTED = 'INFECTED';

export {
    NEW,
    CLEAN,
    INFECTED
};